import { addTraits } from 'stemi-firebase';

export const getCurrentUser = state => addTraits(state.auth.user);

export const getCurrentUserUid = state => state.auth.uid;
